import React, { FC, useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { PdfViewerComponent } from '../../components/PdfViewerComponent/PdfViewerComponent';
import { BlueLayout, PagesContainerUI, TabsContainer } from '../../styles/styled';
import { ExpertiseType } from '../ExpertisePage/types';
import { MainInfoComponent } from './components/MainInfoComponent/MainInfoComponent';
import PovsExpertisesToolbar from './components/PovsExpertisesToolbar';
import { ExpertiseExpertListType } from './types';

const { TabPane } = Tabs;

type PovsExpertisePageProps = {
  edit?: boolean;
  editExpertise?: ExpertiseType;
};

export const PovsExpertisePage: FC<PovsExpertisePageProps> = ({ editExpertise, edit }) => {
  const { id } = useParams();
  const [currentExpertiseState, setCurrentExpertise] = useState<ExpertiseType | undefined>();
  const [currentElState, setCurrentEl] = useState<ExpertiseExpertListType | undefined>();
  const [openBookState, setOpenBook] = useState<string | null>(null);

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const currentExpertiseResponse = await api.get<ExpertiseType>(endpoints.getExpertiseById(id));

          setCurrentExpertise(currentExpertiseResponse.data);

          const currentEl = await api.get<ExpertiseExpertListType>(
            endpoints.getExpertiseListById(currentExpertiseResponse.data?.expertise_list?.id || 0),
          );

          setCurrentEl(currentEl.data);
        } catch (err) {}
      })();
    }
  }, [id]);

  useEffect(() => {
    if (openBookState) {
      document.body.style.overflow = 'hidden';
      window.scrollTo(0, 0);
    } else document.body.style.overflow = 'auto';
  }, [openBookState]);

  useEffect(() => {
    if (edit && editExpertise) setCurrentExpertise(editExpertise);

    // eslint-disable-next-line
  }, [edit]);

  return (
    <PagesContainerUI>
      {openBookState && <PdfViewerComponent closePdfViewer={() => setOpenBook(null)} bookLink={openBookState} />}

      <BlueLayout padding="35px 0 10px 0">{currentExpertiseState?.textbook.title}</BlueLayout>
      <TabsContainer white>
        <Tabs type="card" tabBarGutter={0}>
          <TabPane tab="Основные сведения" key="1">
            <MainInfoComponent expertise={currentExpertiseState} />
          </TabPane>
          <TabPane tab="Экспертиза" key="2">
            <PovsExpertisesToolbar
              setOpenBook={(value: string | null) => setOpenBook(value)}
              expertise_list={currentElState}
              expertise={currentExpertiseState}
            />
          </TabPane>
        </Tabs>
      </TabsContainer>
    </PagesContainerUI>
  );
};
